import NavBar from "framework/ui/content/NavBar";
import PageContent from "framework/ui/content/PageContent";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import React from "react";
import './css/GuestBook.css'
import './css/NavBar.css'
import './css/PageContent.css'
import PageNavigation from "framework/ui/content/PageNavigation";
import PageSwiper from "framework/ui/content/PageSwiper";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (<>
    <div className="TitleWrapper">
      <PageTitle alwaysShow={true}/>
    </div>
    <div className={'PageWrapper'}>
      <NavBar/>
      <div className="PageBackground">
        <PageSwiper {...props}>
          <PageContent>
            <PageSections/>
          </PageContent>
        </PageSwiper>
        <div className="PageFooter">
          <PageNavigation/>
          <Copyright startYear='2022'/>
        </div>
      </div>
    </div>
  </>);
}